module.exports = __webpack_public_path__ + "media/images/diy/facebook-111b16fd92d7fdd657ce8a183d51a735.svg";